// import SubTitle from '../title/sub-title';
// import Banner from '../banner';
import { Steps } from 'antd'
import Flower from '../../../components/flower/flower'
import bonusCover from '../../../images/bonus-cover.png'
const { Step } = Steps

const ActivityIntro = () => {
  const month = new Date().getMonth() + 1
  const date = new Date().getDate()
  return (
    <>
      {/*<Banner />*/}
      <div
        className="jury__line outlineTitle"
        style={{ textAlign: 'center', marginTop: '128px' }}>
        <label className={`enter_label  active `}>赛程安排</label>
      </div>
      <div
        className="home-row schedule_time intro"
        style={{ marginTop: '64px', paddingLeft: '250px' }}>
        <Steps progressDot direction="vertical">
          <Step
            title="2025年6月11日赛事线下启动"
            status={`${month <= 5 ? 'finish' : 'wait'}`}
            className={`${month === 5 ? 'active' : ''}`}
            subTitle="2025年6月"
            description={
              <div>
                <a
                  href="/enter/uncomgroup"
                  style={{ textDecoration: 'underline' }}>
                  开启大赛报名系统，
                </a>
                符合条件的参赛主体通过本页面最下方报名入口，根据实际情况选择“未转化组”或“已转化组”通道，在线填写报名登记表。报名截止时间2025年8月31日。
              </div>
            }
          />
          <Step
            title="初评并公示"
            status={`${month <= 7 ? 'finish' : 'wait'}`}
            className={`${[7, 8].indexOf(month) > -1 ? 'active' : ''}`}
            subTitle="2025年9月"
            description={
              <div>
                报名成功的项目将根据对应组别由大赛组委会进行滚动线上评议，遴选出100个项目进入复赛并进行公示。100强项目将入选组委会《2025上高赛项目价值榜名录》，项目运营单位将入选组委会《2025上高赛机构服务榜》。
                <br />
                {/* 报名截止时间：2022年7月15日。 */}
              </div>
            }
          />
          <Step
            title="培训启动"
            status={`${month <= 9 ? 'finish' : 'wait'}`}
            className={`${month === 9 ? 'active' : ''}`}
            subTitle="2025年9月-10月"
            description={
              <div>
                启动专利运营辅导和路演技能等培训。根据项目需求，面向所有报名项目，开展专利运营公开课，面向100强开展项目把脉问诊辅导课。
              </div>
            }
          />

          <Step
            title="复赛路演及精准对接"
            status={`${month <= 9 ? 'finish' : 'wait'}`}
            className={`${month === 9 ? 'active' : ''}`}
            subTitle="2025年10月-11月"
            description={
              <div>
                邀请行业专家、技术专家、投融资专家等对入围的100个项目进行路演筛评，遴选出20个推荐项目进入决赛。并对外发布“2025上高赛项目价值榜
                TOP20”名单。
                <br />
                每场复赛结束后，组委会邀请评审专家、转化问诊专家、投融资专家、产业专家等与项目进行赛后对接。
              </div>
            }
          />

          <Step
            title="决赛暨颁奖典礼"
            status={`${month <= 10 ? 'finish' : 'wait'}`}
            className={`${month === 10 ? 'active' : ''}`}
            subTitle="2025年12月"
            description="邀请入围决赛的20名优胜者参与线下决赛，参赛者在现场就参赛项目进行路演讲解，评委专家进行现场评选，当场遴选出专利运营潜力奖、专利产业化奖、专利许可转让奖、专利作价入股奖。同期，本次大赛还将设立若干服务贡献奖（100强的运营机构）。"
          />
        </Steps>
      </div>

      <div
        className="jury__line outlineTitle"
        style={{ textAlign: 'center', marginTop: '128px' }}>
        <label className={`enter_label  active `}>大赛奖励</label>
      </div>
      <div className="home-row reward-row">
        <div className="reward-col">
          <p>
            <span>专利运营潜力奖：</span>
            <span>面向未转化组别前6名设置奖项。</span>
          </p>
          <p>
            <span>专利产业化奖：</span>
            <span>面向已转化组别前4名设置奖项。</span>
          </p>
          <p>
            <span>专利许可转让奖：</span>
            <span>面向已转化组别设置该奖项。</span>
          </p>
          <p>
            <span>专利作价入股奖：</span>
            <span>面向已转化组别设置该奖项。</span>
          </p>
        </div>
        <div className="reward-col">
          <p>
            <span>2025上高赛项目价值榜：</span>
            <span>100个。</span>
          </p>
          <p>
            <span>2025上高赛机构服务榜：</span>
            <span>若干。</span>
          </p>
          <p>
            <span>专利运营机构贡献奖：</span>
            <span>项目价值榜Top100项目的运营服务机构获得该奖项。</span>
          </p>
        </div>

        <div style={{ lineHeight: '30px' }}></div>
      </div>

      <div className="home-row" style={{ marginTop: '64px' }}>
        <div className="glod-row">
          <Flower title={'专利运营\n潜力奖'} type={'gold'} />
          <Flower title={'专利\n产业化奖'} type={'gold'} />
          <Flower title={'专利\n许可转让奖'} type={'gold'} />
          <Flower title={'专利\n作价入股奖'} type={'gold'} />
          <Flower title={'专利运营\n机构贡献奖'} type={'gold'} />
        </div>
      </div>
      {/* <div className='home-row bonus-row'>
        <div className='bonus-desc'>2万元现金</div>
        <div className='bonus-desc'>5万元现金</div>
        <div className='bonus-desc'>5万元现金</div>
        <div className='bonus-desc'>5000元现金</div>
        <div className='bonus-desc'>5000元现金</div>
      </div> */}
      <div className="home-row bonus-row" style={{ marginTop: '10px' }}>
        <div className="bonus-desc">
          <span style={{ fontSize: '28px' }}>6</span>个
        </div>
        <div className="bonus-desc">
          <span style={{ fontSize: '28px' }}>4</span>个
        </div>
        <div className="bonus-desc">
          <span style={{ fontSize: '28px' }}>3</span>个
        </div>
        <div className="bonus-desc">
          <span style={{ fontSize: '28px' }}>3</span>个
        </div>
        <div className="bonus-desc">
          <span style={{ fontSize: '28px' }}>若干</span>
        </div>
      </div>
      <div className="home-row" style={{ marginTop: '57px' }}>
        <div className="activity-div-subTitleContainer">
          <div className="titleContainer-div-separator"></div>
          <Flower title={'专利运营\n价值榜\n100个'} type={'blue'} />
          <Flower title={'专利运营\n优秀榜\n若干'} type={'blue'} />
          <div className="titleContainer-div-separator"></div>
        </div>
      </div>

      {/* <div className="home-row bonus-row small"  style={{marginTop: "10px"}}>
            <div className="bonus-desc"></div>
            <div className="bonus-desc">含最后获奖者</div>
            <div className="bonus-desc">含参赛项目相应的运营机构贡献奖</div>
            <div className="bonus-desc"></div>
        </div>
        <div className="home-row bonus-row"  style={{marginTop: "10px"}}>
            <div className="bonus-desc"></div>
            <div className="bonus-desc"><span className="big">100</span>个</div>
            <div className="bonus-desc"><span className="big">10</span>个</div>
            <div className="bonus-desc"></div>
        </div> */}
      <div
        className="home-row bonus-row"
        style={{ marginTop: '64px', width: '80%', justifyContent: 'center' }}>
        <div className="privilege">
          <span className="mainTitle">获奖项目权益：</span>
          <br />
          <ol>
            <li>
              <a
                href="http://www.stte.com"
                target={'_blank'}
                rel={'noreferrer'}>
                所有获奖单位获得荣誉证书；
              </a>
            </li>
            <li>获奖项目将由上海技术交易所协助申报“中国专利奖”；</li>
            <li>
              投融资对接：为企业、科创团队获奖项目提供投资基金和产业对接不少于3次，同时开放多家银行知识产权质押融资对接；
            </li>
            <li>
              产学研合作对接：为高校、科研院所、医疗卫生机构获奖项目提供产学研对接服务不少于1次；
            </li>
            <li>
              申报主体为高校的获奖项目可向组委会申请视频内容传播服务，申请通过的，组委会将成立专项小组，免费拍摄制作项目宣传视频，并通过三家主办单位公众号进行对外宣发；
            </li>
            <li>
              为未转化组和已转化组获奖项目开通上海技术交易所技术交易挂牌绿色通道；
            </li>
            <li>所有获奖项目有机会获主流媒体报道曝光。</li>
            {/* <li>
              <a
                href="https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzU2MTU2ODM2Mg==&action=getalbum&album_id=2295031400917647366&scene=173&from_msgid=2247494549&from_itemidx=1&count=3&nolastread=1#wechat_redirect"
                target={'_blank'}
                rel={'noreferrer'}>
                《上技会客厅》
              </a>
              栏目专访，及“
              <a
                href="http://www.stte.com/roadshows"
                target={'_blank'}
                rel={'noreferrer'}>
                上技路演
              </a>
              ”项目360度项目推广
            </li> */}
          </ol>
          {/* <br />
          <br />
          <br />
          <br /> */}
        </div>
        {/* <div className="cover">
          <img src={bonusCover} alt={''} />
        </div> */}
      </div>
      <div
        className="home-row bonus-row"
        style={{
          marginTop: '128px',
          marginBottom: '128px',
          justifyContent: 'center',
        }}>
        <button
          type="button"
          className="blueButton"
          onClick={() => (window.location.href = '/enter/uncomgroup')}
          style={{ width: '216px', height: '64px' }}>
          未转化组报名入口
        </button>
        <button
          type="button"
          className="blueButton"
          onClick={() => (window.location.href = '/enter/comgroup')}
          style={{
            width: '216px',
            height: '64px',
            marginLeft: '60px',
          }}>
          已转化组报名入口
        </button>
      </div>
    </>
  )
}

export default ActivityIntro
